import AsyncButton from "@components/button/AsyncButton.component";
import { ChangeEvent, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

interface Props {
    header: string;
    message: string;
    onConfirm?: () => void;
    onClose?: () => void;
    show: boolean;
    confirmationButtonVariant?: string;
    confirmationButtonText: string;
    typedValueExpectation?: string;
    confirmIcon?: string;
}

function ConfirmationModal({header, message, onConfirm, show, typedValueExpectation, onClose, confirmationButtonText, confirmationButtonVariant='success', confirmIcon='mdi-check'}: Props) {
    const [typedValue, setTypedValue] = useState('');
    const [confirming, setConfirming] = useState(false);
    const confirm = async () => {
        setConfirming(true);
        !!onConfirm && await onConfirm();
        setTypedValue('');
        setConfirming(false);
    }

    const close = () => {
        setTypedValue('');
        !!onClose && onClose();
    }
    return (
        <Modal show={show} onHide={close}>
            <Modal.Header closeButton>
                <Modal.Title>{header}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{message}</p>

                {typedValueExpectation && (
                    <Form.Control placeholder="Name" value={typedValue} onChange={(e: ChangeEvent) => setTypedValue((e.target as HTMLInputElement).value)} type="text" size="lg"/>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={close}>
                    Close
                </Button>
                <AsyncButton
                    icon={`mdi ${confirmIcon}`}
                    variant={confirmationButtonVariant}
                    disabled={!!typedValueExpectation && (typedValueExpectation as string !== typedValue)}
                    onClick={confirm}
                    text={confirmationButtonText}
                    loading={confirming}
                ></AsyncButton>                
            </Modal.Footer>
        </Modal>
    );
    
}

export default ConfirmationModal;